import {
  UNIV_DEGREE,
  UNIV_MINOR,
  UNIV_SCHOOL,
  UNIV_YEARS,
  UNIV_GPA,
  UNIV_HONORS,
  UNIV_CONCENTRATION,
  UNIV_LOCATION,
} from "../data/ResumeData";
import SectionHeader from "./SectionHeader";

function Education() {
  return (
    <section aria-labelledby="education-heading">
      <SectionHeader title="Education" />
      <h2 id="education-heading" className="sr-only">Education</h2>

      <article className="flex items-baseline justify-between gap-4">
        <div className="min-w-0">
          <h3 className="font-display text-[1.0625rem] leading-tight">
            {UNIV_SCHOOL}
          </h3>
          <p className="mt-1 text-[13.5px] text-fg-muted leading-snug">
            B.S. {UNIV_DEGREE.replace("Bachelor of Science in ", "")}
            <span aria-hidden="true" className="mx-2 text-fg-subtle/60">·</span>
            <span className="text-fg-subtle">Concentration: {UNIV_CONCENTRATION}</span>
          </p>
          <p className="mt-0.5 text-[13.5px] text-fg-muted leading-snug">
            <span className="text-fg-subtle">Minor: {UNIV_MINOR}</span>
          </p>
          <p className="mt-1.5 text-[12.5px] text-fg-subtle">
            <span className="tabular-nums">{UNIV_GPA} GPA</span>
            <span aria-hidden="true" className="mx-2 text-fg-subtle/60">·</span>
            {UNIV_HONORS}
            <span aria-hidden="true" className="mx-2 text-fg-subtle/60">·</span>
            {UNIV_LOCATION}
          </p>
        </div>
        <span className="text-[12.5px] tabular-nums whitespace-nowrap text-fg-subtle shrink-0">
          {UNIV_YEARS}
        </span>
      </article>
    </section>
  );
}

export default Education;
